import type {
    OnboardingApplicationLogsPaginator,
    OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges
} from "../types";

export const attachPreviousChanges = ({ data, ...paginator }: OnboardingApplicationLogsPaginator<
    Record<
        string,
        OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges[]
    >
>) => ({
    ...paginator,
    data: Object.entries(data)
        .reduce((acc, [key, value]) => ({
            ...acc,
            [key]: value.map((entry, index, array) => ({
                ...entry,
                previousChanges: array[index - 1]?.changes
            }))
        }), {})
});
